//
// Javascript standalone functions used as helpers
//
//  Matt Smith
//  January 2012
//

//IE9 console isn't defined when the developer tools aren't open
(function checkConsoleCompatibility() {
  if (typeof console == "undefined") {
    console = {log: function() {}, info: function() {}, warn: function() {}, error: function() {} };
  }
})();
// Extending string function
// Ivan Markov
// March 2012
//pads left
String.prototype.lpad = function (padString, length) {
  var str = this;
  while (str.length < length)
    str = padString + str;
  return str;
};

//pads right
String.prototype.rpad = function (padString, length) {
  var str = this;
  while (str.length < length)
    str = str + padString;
  return str;
};